import React, { useEffect, useMemo, useState } from "react";
import { UiComponents, UnoStoreHooks, DashboardIcon } from "@simulanisindia/ui";

import { useNavigate, useLocation } from "react-router-dom";
import {
  BottomActiveBar,
  ProjectListActiveIcon,
  ProjectListiIcon,
  TeamDashboardActive,
  TeamDashboardIcon,
} from "../../assets/icons/icons";

const { useUnoSelector } = UnoStoreHooks;

const BottomNavigationBar = () => {
  const userData = useUnoSelector((state) => state.user);
  const isUserAvatar = true;
  const navigate = useNavigate();
  const location = useLocation();
  const uuid = userData?.user?.group?.uuid;
  const navItems = [
    {
      id: "team",
      label: "Team Dashboard",
      icon: <TeamDashboardIcon />,
      iconActive: <TeamDashboardActive />,
      path: `/dashboard/${userData?.user?.group?.uuid}`,
    },
    {
      id: "projects",
      label: "Projects",
      icon: <ProjectListiIcon />,
      iconActive: <ProjectListActiveIcon />,
      path: `/project/${userData?.user?.group?.uuid}`,
    },
  ];

  const pathname = location.pathname;

  const activeNav = useMemo(() => {
    if (pathname.startsWith("/dashboard/")) return "team";
    if (pathname.startsWith("/project")) return "projects";
    if (pathname.startsWith("/editor")) return "projects";
    return "";
  }, [pathname]);

  const handleClick = (item) => {
    navigate(item.path);
  };

  useEffect(() => {
    const onEditor = pathname.startsWith("/editor");

    if (onEditor) {
      document.body.classList.add("editorMode");
    } else {
      document.body.classList.remove("editorMode");
    }

    return () => document.body.classList.remove("editorMode");
  }, [pathname]);

  if (pathname.startsWith("/editor")) return null;

  return (
    <div className="bottomNavigation">
      <>
        {navItems.map((item) => (
          <div
            key={item.id}
            // className={`navigateItem active `}
            className={`navigateItem ${activeNav === item.id ? "active" : ""}`}
            onClick={() => handleClick(item)}
          >
            <span className="navigateIcon">
              {/* <>{item.icon}</> */}
              {/* <>{item.iconActive}</> */}
              <>{activeNav === item.id ? item.iconActive : item.icon}</>
            </span>
            <span className="navigateText">{item.label}</span>
            {activeNav === item.id && (
              <span className="activeIndicator">
                <BottomActiveBar />
              </span>
            )}
          </div>
        ))}
      </>
    </div>
  );
};
export default BottomNavigationBar;
